<template>
  <div :style="{ display: 'flex', justifyContent: 'center' }">
    <div class="slideshow-container">
      <div class="slideshow-back-button">
        <span
          @click="$router.go(-1)"
          :style="{ color: getPrimaryColor(), cursor: 'pointer' }"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: getPrimaryColor() }"
            :icon="['fas', 'arrow-left']"
          />
          Back</span
        >
      </div>
      <div class="slideshow-title">{{ video.article_title }}</div>
      <p>
        <span
          v-html="video.article_description"
          class="slideshow-description"
        ></span>
      </p>
      <p>
        <a-carousel
          autoplay
          :dots="false"
          effects="fade"
          class="carosal_class"
          :autoplaySpeed="15000"
          ref="carouselRef"
          :afterChange="change => (currentSlide = change + 1)"
        >
          <div v-for="(vid, i) in video.article_attach" v-bind:key="i">
            <div :style="{ display: 'flex', flexDirection: 'column' }">
              <img
                class="slide-img"
                :src="vid.main_image"
                width="100%"
                height="500px"
                alt="image"
              />
            </div>
          </div>
        </a-carousel>
      </p>
      <!-- <hr /> -->
      <div class="slideshow-button-center">
        <div class="slideshow-button-container">
          <font-awesome-icon
            class="mr-2"
            :style="{ color: getPrimaryColor(), cursor: 'pointer' }"
            :icon="['fas', 'arrow-left']"
            @click="() => $refs.carouselRef.prev()"
          />
          <div class="slideshow-button-text">
            {{ currentSlide }} / {{ video.article_attach.length }}
          </div>
          <font-awesome-icon
            class="mr-2"
            :style="{ color: getPrimaryColor(), cursor: 'pointer' }"
            :icon="['fas', 'arrow-right']"
            @click="() => $refs.carouselRef.next()"
          />
        </div>
      </div>
      <p>
        <b class="slideshow-img-title">{{
          video.article_attach[currentSlide - 1].title
        }}</b>
      </p>
      <div
        class="slideshow-img-description"
        v-html="video.article_attach[currentSlide - 1].caption"
      ></div>
    </div>
  </div>
</template>

<script>
import SharePostModal from "../../../Modals/SharePost";
import moment from "moment";
import { Carousel } from "ant-design-vue";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faArrowLeft);
library.add(faArrowRight);

export default {
  name: "SlideshowContent",
  props: {
    videoData: Object
  },
  components: {
    "a-carousel": Carousel
  },
  data() {
    return {
      video: null,
      currentSlide: 1
    };
  },
  components: {
    SharePostModal
  },

  mounted() {
    this.video = this.videoData;
  },

  filters: {
    updatedAt(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  },

  methods: {
    /**
     * Limit description text limit
     *
     * @param {String} description
     */
    getLimitedDescription(description) {
      const div = document.createElement("div");
      div.innerHTML = description;
      const text = div.textContent || div.innerText || "";

      return text.length > 150 ? text.substring(0, 150) + "..." : text;
    }
  }
};
</script>

<style lang="scss" scoped>
// .ant-carousel >>> .custom-slick-arrow {
//   width: 25px;
//   height: 25px;
//   font-size: 25px;
//   color: #1674bf;
// }
// .ant-carousel >>> .custom-slick-arrow:before {
//   display: none;
// }
@media screen and (max-width: 581px) {
  .share-button {
    font-size: 14px;
  }
  .last-update {
    font-size: 10px;
  }
  .back-button {
    font-size: 12px;
  }
  .view-resource {
    font-size: 12px;
  }
}
// .ant-carousel >>> ul.slick-dots {
//   bottom: 0px !important;
//   @media screen and (max-width: 900px) {
//     margin-bottom: 0px !important;
//   }
// }

.slideshow-container {
  // margin-left: 121px;
  // margin-right: 121px;
  width: 60%;
  min-width: 300px;
  margin-top: 47px;
  @media only screen and (max-width: 700px) {
    margin-top: 24px;
    padding: 0px 16px;
    width: 100%;
  }
}

.slideshow-back-button {
  font-family: "Lato";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 48px;
  @media only screen and (max-width: 700px) {
    margin-bottom: 24px;
  }
  text-align: start;
}

.slideshow-title {
  font-family: "Lato";
  font-weight: 700;
  font-size: 36px;
  line-height: 46px;
  color: #1e2945;
  margin-bottom: 16px;
}

.slideshow-description > p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: #647490;
  margin-bottom: 48px;
}

.slideshow-img-title {
  font-family: "Lato";
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #1e2945;
  margin-bottom: 16px;
  margin-top: 24px;
}

.slideshow-img-description {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: #647490;
  margin-bottom: 200px;
}

.slide-img {
  max-width: 100%;
  align-self: center;
  height: 500px;
  object-fit: contain;
  @media only screen and (max-width: 700px) {
    height: 165px;
  }
}

.slideshow-button-center {
  display: flex;
  justify-content: center;
}

.slideshow-button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 14px;
  width: 199px;
  height: 52px;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 10px;
  margin-bottom: 40px;
}

.slideshow-button-text {
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
}
.slideshow-button {
  font-family: "Lato";
  font-weight: 700;
  font-size: 30px;
  line-height: 24px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/home/resources/contents/Slideshow.vue